import { useContext } from 'react';
import { AcctContext } from '../utility/useReduce/userNameReduce';

/**
 * 自定義 Hook：取得指定功能的可編輯狀態
 * @param {string} functionId - 功能 ID
 * @returns {boolean} 是否可編輯
 */
export const useEditableFlag = (functionId) => {
    const [state] = useContext(AcctContext);
    return state?.editableFlags?.[functionId] === 'Y';
};

/**
 * 自定義 Hook：取得所有功能的可編輯狀態
 * @returns {object} 所有功能的可編輯狀態對應表
 */
export const useAllEditableFlags = () => {
    const [state] = useContext(AcctContext);
    return state?.editableFlags || {};
};

/**
 * 自定義 Hook：取得功能清單
 * @returns {array} 功能清單
 */
export const useFunctions = () => {
    const [state] = useContext(AcctContext);
    return state?.functions || [];
};
